export default __webpack_public_path__ + "static/media/im-placeholders-error.43a66cb9.svg";